<script>
  export default {
    functional: true,
    render(createElement) {
      return createElement("div", {
        staticClass: "mr-spinner"
      }, [createElement("div", {
        staticClass: "spinner"
      })])
    }
  }
</script>

<style scoped lang="stylus">
  .mr-spinner
    position relative

    .spinner
      margin auto
      border none
      height 2em
      width 2em
      -webkit-animation spin 1s linear infinite
      -moz-animation spin 1s linear infinite
      animation spin 1s linear infinite

      &:before
        content icon-process
        font-family "fontello"
        font-size 2em
        width 1em
        height 1em
        position absolute
        top 0
        right 0
        bottom 0
        left 0
        color color-mr-purple

</style>
